import { Component, Input } from '@angular/core';
import { ICompany } from '../../../../core/models/ICompany';
import { RouterLink } from "@angular/router";
import { UserService } from '../../../../core/services/user.service';
import { IUser } from '../../../../core/models/IUser';
import { environment } from '../../../../../environments/environment';
import { LogService } from '../../../../core/services/log.service';

@Component({
  selector: 'app-company-card',
  imports: [RouterLink],
  templateUrl: './company-card.html',
  styleUrl: './company-card.scss'
})
export class CompanyCard {

  @Input() company! : ICompany;
  user: IUser | null;
  apiUrl = environment.apiUrl;
  starsArray: string[] = [];

  constructor(private userService: UserService,private logger: LogService) {
    this.user= this.userService.currentUser;
  }

  ngOnInit(): void {
    this.starsArray = this.getStarsArray(this.company.averageRating);
  }

  getStarsArray(rating: number): string[] {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.2;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    return [
      ...Array(fullStars).fill('full'),
      ...(hasHalfStar ? ['half'] : []),
      ...Array(emptyStars).fill('empty')
    ];
  }

  toggleFavorite(company: ICompany) {
    if (!this.user) {
      alert('Veuillez vous connecter pour gérer vos favoris.');
      return;
    }
    if (this.user.favorites.includes(company._id)) {
      this.userService.removeFromFavorites(company._id).subscribe({
        next: (message) => {
          this.user = this.userService.currentUser;
        },
        error: (err) => {
          this.logger.error('Erreur lors de la suppression des favoris: ' + JSON.stringify(err));
        }
      });
    } else {
      this.userService.addToFavorites(company._id).subscribe({
        next: (message) => {
          this.user = this.userService.currentUser;
        },
        error: (err) => {
          this.logger.error('Erreur lors de l\'ajout aux favoris: ' + JSON.stringify(err));
        }
      });
    }
  }
}
